module.exports = __webpack_public_path__ + "static/noise-11f09edad695dfabf71e6961b7e78afd.png";